import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import ID from '../../_helpers/uuid';
import { css } from 'twin.macro';
import { useState, useEffect, Fragment, useRef, useContext, useMemo } from 'react';
import { connect } from 'react-redux';
import { BsChevronCompactDown } from 'react-icons/bs';
import { combineReListings, createGeoLocationSearchHandlers, getMapChannels } from './utils';
import useGeoLocationRealEstate from './hooks/useGeoLocationRealEstate';

import GoogleMap from './GoogleMap';
import { realEstateListingsApi } from '../../_services/api/realEstate/listings';
import { realEstateMapIntentApi } from '../../_services/api/realEstate/mapIntent';
import { placesSearchApi } from '../../_services/api/places/placesSearch';
import {
    CreateChannelModal,
    CreateChannelToggle,
    GeoLocationOverlays,
    MapSearchControl,
    PublicChannelEvents,
    createMapInfoRenderer,
} from './components';
import { chatroomsApi } from '@/_services/api/chatroom/chatrooms';
import { fetchWrapper, getLatLngFromAddress, toastWrapper } from '../../_helpers';
import { getPublicTask, getTaskByassignedToId } from '../../_redux/actions/ActionTasks';
import { WebSocketContext } from '../../_redux/actions/ActionSocket';
import dayjs from 'dayjs';
import UpcomingEvents from './components/UpcomingEvents';
import BobChatWidget from '../Features/Chat/BobChatWidget';
import ComponentErrorBoundary from '../../Layouts/ComponentErrorBoundary';

const MapContainer = styled.div`
    position: relative;
    width: 100vw;
    height: 100vh;
`;

const ChannelModeOnIndicator = styled.div`
    position: absolute;
    z-index: 2;
    top: 0;
    left: 50%;
    transform: translate(-50%, -30%);
    background-color: #24637f;
    color: white;
    padding: 1rem 5rem 1.5rem;
    border-bottom-right-radius: 35%;
    border-bottom-left-radius: 35%;
    transition: transform 400ms 400ms;
    p {
        width: 360px;
        text-align: center;
    }
    .downarrowContainer {
        text-align: center;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    :hover {
        transform: translate(-50%, 0);
    }
`;
export const eventTypeIcon = css`
    width: 48px;
    height: 48px;
    border-radius: 50%;
`;

export const eventTypeContainer = css`
    position: absolute;
    // display: flex;
    // gap: 12px;
    // width: 80%;
    // margin: 0 10%;
    left: 10px;
    top: 10%;
    width: 120px;
    padding: 3rem 1rem;
    opacity: 1;
    max-height: 90vh;
    overflow: auto;
    border-radius: 10px;
    // box-shadow:
    //     rgba(50, 50, 93, 0.25) 0px 0px 60px -18px inset,
    //     rgba(50, 50, 93, 0.25) 0px 0px 60px -18px inset;
`;
export const eventTypeItem = css`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    background-color: #50aeb0;
    // padding: 6px 12px;
    padding: 3px;
    padding-top: 12px;
    margin-bottom: 1rem;
    border-radius: 12px;
    cursor: pointer;
    p {
        white-space: nowrap;
        color: #ffffff;
        margin: 1px 0;
    }
`;

const GeoLocation = ({
    position,
    errorMessage,
    userId,
    taskList,
    getPublicTask,
    getTaskByassignedToId,
    ui,
    upcomingTaskList,
}) => {
    const [pos, setPos] = useState(null);
    const [error, setError] = useState('');
    const [isChannelCreateSelected, setIsChannelCreateSelected] = useState();
    const [sholudUpdatePublicChannels, setSholudUpdatePublicChannels] = useState(null);

    const [showCreateChannelModal, setShowCreateChannelModal] = useState(false);
    const [channelLatLong, setChannelLatLong] = useState({});

    // State variables for map overlays
    const [showTraffic, setShowTraffic] = useState(false);
    const [showTransit, setShowTransit] = useState(false);
    const [showEventRoutes, setShowEventRoutes] = useState(false);
    const [showBobChat, setShowBobChat] = useState(false);
    const [showCreateEvent, setShowCreateEvent] = useState(false);
    const [eventPrefill, setEventPrefill] = useState(null);

    useEffect(() => {
        if (!showCreateEvent) setEventPrefill(null);
    }, [showCreateEvent]);

    const inputRef = useRef();
    const mapIntentRequestIdRef = useRef(0);
    const [search, setSearch] = useState('');
    const [searchLoading, setSearchLoading] = useState(false);

    const [filteredResults, setFilteredResults] = useState([]);
    const [mapLatitude, setMapLatitude] = useState();
    const [mapLongitude, setMapLongitude] = useState();
    const [searchedRoomId, setSearchedRoomId] = useState();
    // const [pageNo, setPageNo] = useState(1);
    const [chatroomEvents, setChatroomEvents] = useState([]);
    const [isEvents, setIsEvents] = useState(false);

    const [activeEvent, setActiveEvent] = useState({});
    const [activeChannel, setActiveChannel] = useState(null);

    const [publicChannels, setPublicChannels] = useState([]);
    const [campuses, setCampuses] = useState([]);
    // Real Estate listings mode + data
    const {
        showRealEstate,
        setShowRealEstate,
        reListings,
        setReFilters,
        reBobConfirm,
        setReBobConfirm,
        reLoading,
        selectedListing,
        setSelectedListing,
        nearbyVisitProperties,
        loadListings,
        handleSearch: handleReSearch,
        handlePropertyLabelChange,
        confirmReBob,
        removeReFilter,
        openPropertyChannel,
        filterChips,
    } = useGeoLocationRealEstate({
        realEstateListingsApi,
        realEstateMapIntentApi,
        mapIntentApi: placesSearchApi,
        chatroomsApi,
        toastWrapper,
    });
    // Visit proximity — properties near recent SOS/EOS/Quicknote form submissions
    const [reLabelFilter, setReLabelFilter] = useState('');

    // Places mode + data
    const [showPlaces, setShowPlaces] = useState(false);
    const [placesResults, setPlacesResults] = useState([]);
    const [placesLoading, setPlacesLoading] = useState(false);
    const [selectedPlace, setSelectedPlace] = useState(null);

    // Local search (near me / campus) — channels from Optonome, not Google Places
    const [localSearchResults, setLocalSearchResults] = useState([]);

    // Event types for matching search keywords to event icons
    const [eventTypes, setEventTypes] = useState([]);

    const [searchMode, setSearchMode] = useState('channels');

    // Toggle functions for map overlays
    const toggleTraffic = () => setShowTraffic(!showTraffic);
    const toggleTransit = () => setShowTransit(!showTransit);
    const toggleEventRoutes = () => setShowEventRoutes(!showEventRoutes);
    const toggleBobChat = () => setShowBobChat(!showBobChat);
    const toggleCreateEvent = () => setShowCreateEvent(!showCreateEvent);
    const handleAddPlaceToCalendar = (place) => {
        const rawLatitude = place?.location?.latitude ?? place?.location?.lat;
        const rawLongitude = place?.location?.longitude ?? place?.location?.lng;
        const latitude = rawLatitude == null || rawLatitude === '' ? NaN : Number(rawLatitude);
        const longitude = rawLongitude == null || rawLongitude === '' ? NaN : Number(rawLongitude);
        const address = place?.formattedAddress || '';
        setEventPrefill({
            title: place?.name || '',
            location:
                (Number.isFinite(latitude) && Number.isFinite(longitude)) || address
                    ? {
                          lat: Number.isFinite(latitude) ? latitude : null,
                          lng: Number.isFinite(longitude) ? longitude : null,
                          address,
                      }
                    : undefined,
        });
        setShowCreateEvent(true);
    };

    // Filter upcoming tasks to include only events with location data
    const eventsWithLocations = useMemo(() => {
        return upcomingTaskList
            .filter((event) => event?.location && (event.location?.lat || event.location?.address))
            .map((event) => ({
                ...event,
                location: { ...event.location },
            }));
    }, [upcomingTaskList]);

    const getPulicGpsChatroom = async () => {
        try {
            let res = await fetchWrapper.get('/chatrooms/publicgps');
            setPublicChannels(res);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getPulicGpsChatroom();
        placesSearchApi
            .getCampuses()
            .then((response) => setCampuses(response?.results || response?.data?.results || []))
            .catch((error) => console.error('Failed to load campuses:', error));
        // Fetch all event types for keyword-to-icon matching on search results
        fetchWrapper
            .get('eventType?sortBy=title:asc&limit=50')
            .then((res) => setEventTypes(res?.results || res || []))
            .catch((err) => console.error('Failed to fetch event types:', err));
    }, []);

    const ws = useContext(WebSocketContext);
    useEffect(() => {
        if (ws && ws.socket) {
            ws.socket.on('public_gps_pin_expires', (roomId) => {
                getPulicGpsChatroom();
            });
        }
        return () => {
            if (ws && ws.socket) {
                ws.socket.off('public_gps_pin_expires');
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [areEventsFetching, setAreEventsFetching] = useState(false);
    const [selectedMonthYear, setSelectedMonthYear] = useState(dayjs(dayjs().format('YYYY-MM-DD')).format('YYYY-MM'));

    const updateAssignedUsers = (taskId, newAssignedUsers) => {
        setChatroomEvents((prev) =>
            prev.map((taskData) =>
                taskData._id === taskId ? { ...taskData, assignedUser: newAssignedUsers } : taskData
            )
        );
    };

    const [fetchedEventTypes, setFetchedEventTypes] = useState([]);
    const [fetchedChannels, setFetchedChannels] = useState([]);

    useEffect(() => {
        if (!Array.isArray(taskList)) {
            return;
        }
        const filteredEvents = taskList?.filter((event) =>
            activeChannel
                ? (Array.isArray(event?.assignedChannel) ? event.assignedChannel : [event?.assignedChannel])
                      .map((channel) => (typeof channel === 'object' ? channel?._id || channel?.id : channel))
                      .some((channelId) => String(channelId) === String(activeChannel))
                : true
        );
        // fileteredeben
        setChatroomEvents(filteredEvents);

        setIsEvents(activeChannel || activeEvent?._id);
    }, [taskList, activeChannel]);

    const handleChatroomsEvents = async (chatroomId, eventTypeId) => {
        try {
            setAreEventsFetching(true);
            setActiveEvent({});
            setActiveChannel(chatroomId);
            setSearch('');
            if (!chatroomId && eventTypeId && !fetchedEventTypes.includes(eventTypeId)) {
                await getPublicTask(eventTypeId);
                setFetchedEventTypes((prev) => [...prev, eventTypeId]);
            }
            if (chatroomId && !fetchedChannels.includes(chatroomId)) {
                await getPublicTask(null, chatroomId);
                setFetchedChannels((prev) => [...prev, chatroomId]);
            }
        } catch (e) {
            console.log(error);
        } finally {
            setAreEventsFetching(false);
        }
    };

    const handleCloseCreateChannelModal = () => {
        setShowCreateChannelModal(false);
    };
    const handleToggleChannelCreate = () => {
        setIsChannelCreateSelected(!isChannelCreateSelected);
    };

    const updatePublicChannelsInMap = () => {
        setSholudUpdatePublicChannels(ID.uuid());
    };

    useEffect(() => {
        if (position) {
            setPos(position);
        } else if (errorMessage) {
            setError(errorMessage);
        }
    }, [position, errorMessage]);

    const { handleMapSearch } = createGeoLocationSearchHandlers({
        eventTypes,
        publicChannels,
        campuses,
        pos,
        inputRef,
        mapIntentRequestIdRef,
        placesSearchApi,
        toastWrapper,
        setPlacesResults,
        setSelectedPlace,
        setPlacesLoading,
        setActiveChannel,
        setSearch,
        setLocalSearchResults,
        setFilteredResults,
        showRealEstate,
        setReFilters,
        setReBobConfirm,
        loadListings,
        handleSearch: handleReSearch,
        showPlaces,
        setShowRealEstate,
        setShowPlaces,
    });

    const clearSearch = () => {
        // setPageNo(1);
        setSearch('');
        setFilteredResults([]);
        setChatroomEvents([]);
        setIsEvents(false);
        inputRef.current.value = '';
        setLocalSearchResults([]);

        if (showRealEstate) {
            setReFilters({});
            setReBobConfirm(null);
            setSelectedListing(null);
            loadListings({});
        }
        if (showPlaces) {
            setPlacesResults([]);
            setSelectedPlace(null);
        }
    };
    const searchByChannelAndEventType = async (search, pageNo = 1) => {
        try {
            setSearchLoading(true);
            setFilteredResults(publicChannels.filter((channel) => new RegExp(search, 'i').test(channel.title)));
            const response = await fetchWrapper.get(`publicRoomTasks?limit=100&page=${pageNo}&title=${search}`);
            setChatroomEvents(response.results);
            setIsEvents(true);
        } catch (err) {
            if (err?.name === 'AbortError') return;
            toastWrapper.error(err.message);
        } finally {
            setSearchLoading(false);
        }
    };

    const searchByLocation = async (search) => {
        try {
            setSearchLoading(true);
            const locationData = await getLatLngFromAddress(search);
            if (!locationData) {
                return;
            }
            setFilteredResults([
                {
                    title: `${search} ( ${Math.round(locationData.latitude * 1000) / 1000}, ${Math.round(locationData.longitude * 1000) / 1000} )`,
                    _id: `LOCATION_${Date.now()}`,
                    addresses: [locationData],
                },
            ]);
        } catch (err) {
            toastWrapper.error(err.message);
        } finally {
            setSearchLoading(false);
        }
    };
    const onMapSearch = (result) => {
        /LOCATION/.test(result._id) || setSearchedRoomId(result._id);
        const [channelAddress] = result.addresses;
        setMapLatitude(channelAddress.latitude);
        setMapLongitude(channelAddress.longitude);
        clearSearch();
        inputRef.current.value = result.title;
        setActiveEvent({});
    };

    const handleCloseActiveEvent = () => {
        setActiveEvent({});
    };
    const handleHideEventsModal = () => {
        setIsEvents(false);
        setActiveEvent({});
    };

    useEffect(() => {
        if (search?.trim() && !searchLoading) {
            searchMode === 'channels' ? searchByChannelAndEventType(search) : searchByLocation(search);
        }
    }, [search]);

    useEffect(() => {
        if (!activeEvent?._id) return;

        const updated = taskList.find((t) => t._id === activeEvent._id || t.id === activeEvent.id);
        if (updated) setActiveEvent(updated);
    }, [taskList]);

    // Combined RE listings — merge standard listings with nearby-visit properties.
    // Visit proximity properties (near SOS/EOS/Quicknote form submission locations
    // and routes between them) are included automatically — no toggle, they just
    // show up as part of RE discovery.
    const combinedReListings = useMemo(
        () => combineReListings(reListings, nearbyVisitProperties),
        [reListings, nearbyVisitProperties]
    );

    // Memoize channel arrays passed to GoogleMap to prevent marker remounting on every render
    const mapChannels = useMemo(
        () =>
            getMapChannels({
                showRealEstate,
                showPlaces,
                combinedReListings,
                placesResults,
                localSearchResults,
                publicChannels,
                search,
                filteredResults,
                isEvents,
                chatroomEvents,
            }),
        [
            showRealEstate,
            showPlaces,
            combinedReListings,
            placesResults,
            publicChannels,
            localSearchResults,
            search,
            filteredResults,
            isEvents,
            chatroomEvents,
        ]
    );

    return (
        <Fragment>
            {pos && (
                <MapContainer>
                    {isChannelCreateSelected ? (
                        <ChannelModeOnIndicator>
                            <p>
                                <i>Click on your desired location, and create a channel</i>
                            </p>
                            <div className="mt-3 text-center">
                                Create channel mode ON
                                <div className="downarrowContainer">
                                    <BsChevronCompactDown />
                                </div>
                            </div>
                        </ChannelModeOnIndicator>
                    ) : null}
                    <ComponentErrorBoundary componentErrorMessage="Failed to load map">
                        <GoogleMap
                            lat={mapLatitude ? mapLatitude : pos.coords.latitude}
                            lng={mapLongitude ? mapLongitude : pos.coords.longitude}
                            isChannelCreateSelected={isChannelCreateSelected}
                            setShowCreateChannelModal={setShowCreateChannelModal}
                            setChannelLatLong={setChannelLatLong}
                            sholudUpdatePublicChannels={sholudUpdatePublicChannels}
                            searchedRoomId={searchedRoomId ? searchedRoomId : ''}
                            handleChatroomsEvents={handleChatroomsEvents}
                            setIsEvents={setIsEvents}
                            isEvents={isEvents}
                            chatroomEvents={chatroomEvents}
                            publicChannels={mapChannels}
                            handleHideEventsModal={handleHideEventsModal}
                            handleCloseActiveEvent={handleCloseActiveEvent}
                            searchActive={showRealEstate || showPlaces || localSearchResults.length > 0}
                            // Real Estate overlay when enabled
                            infoRenderer={createMapInfoRenderer({
                                showRealEstate,
                                showPlaces,
                                combinedReListings,
                                placesResults,
                            })}
                            // Map overlays
                            showTraffic={showTraffic}
                            showTransit={showTransit || showRealEstate}
                            showEventRoutes={showEventRoutes}
                            toggleTraffic={toggleTraffic}
                            toggleTransit={toggleTransit}
                            toggleEventRoutes={toggleEventRoutes}
                            // Upcoming events with locations (still shown)
                            upcomingEvents={eventsWithLocations}
                        />
                    </ComponentErrorBoundary>
                    <MapSearchControl
                        inputRef={inputRef}
                        showRealEstate={showRealEstate}
                        showPlaces={showPlaces}
                        searchLoading={searchLoading}
                        search={search}
                        searchMode={searchMode}
                        setSearchMode={setSearchMode}
                        handleMapSearch={handleMapSearch}
                        clearSearch={clearSearch}
                        filteredResults={filteredResults}
                        onMapSearch={onMapSearch}
                    />
                    <GeoLocationOverlays
                        realEstateOverlayProps={{
                            showRealEstate,
                            onClose: () => {
                                setShowRealEstate(false);
                                setSelectedListing(null);
                            },
                            selectedListing,
                            setSelectedListing,
                            reBobConfirm,
                            setReBobConfirm,
                            confirmReBob,
                            filterChips,
                            removeReFilter,
                            reLoading,
                            combinedReListings,
                            reLabelFilter,
                            setReLabelFilter,
                            onSelectListing: (item) => {
                                setSelectedListing(item);
                                setSearchedRoomId(item.id);
                                setMapLatitude(item.latitude);
                                setMapLongitude(item.longitude);
                            },
                            onOpenChannel: openPropertyChannel,
                            onLabelChange: handlePropertyLabelChange,
                        }}
                        placesOverlayProps={{
                            showPlaces,
                            showRealEstate,
                            selectedPlace,
                            onClose: () => {
                                setShowPlaces(false);
                                setSelectedPlace(null);
                                setPlacesResults([]);
                            },
                            onBack: () => setSelectedPlace(null),
                            placesLoading,
                            placesResults,
                            onAddToCalendar: handleAddPlaceToCalendar,
                            onSelectPlace: (item) => {
                                setSelectedPlace(item);
                                setSearchedRoomId(item.id);
                                if (item.location) {
                                    setMapLatitude(item.location.latitude);
                                    setMapLongitude(item.location.longitude);
                                }
                            },
                        }}
                    />

                    {/* Default: events/tasks list overlay */}
                    {isEvents && !showRealEstate && !showPlaces && (
                        <PublicChannelEvents
                            // label={activeEventType && eventTypes.find((type) => type.id === activeEventType)?.title}
                            chatroomEvents={activeEvent?._id ? [activeEvent] : chatroomEvents}
                            userId={userId}
                            updateAssignedUsers={updateAssignedUsers}
                            areEventsFetching={areEventsFetching || searchLoading}
                            activeEvent={activeEvent}
                            handleHideEventsModal={handleHideEventsModal}
                        />
                    )}
                </MapContainer>
            )}
            <CreateChannelToggle
                isChannelCreateSelected={isChannelCreateSelected}
                handleToggleChannelCreate={handleToggleChannelCreate}
                // Pass map overlay state and toggle functions
                showTraffic={showTraffic}
                showTransit={showTransit}
                showEventRoutes={showEventRoutes}
                showCreateEvent={showCreateEvent}
                showBobChat={showBobChat}
                toggleTraffic={toggleTraffic}
                toggleTransit={toggleTransit}
                toggleEventRoutes={toggleEventRoutes}
                toggleCreateEvent={toggleCreateEvent}
                toggleBobChat={toggleBobChat}
            />
            {showCreateChannelModal && (
                <CreateChannelModal
                    show={showCreateChannelModal}
                    handleClose={handleCloseCreateChannelModal}
                    channelLatLong={channelLatLong}
                    updatePublicChannelsInMap={updatePublicChannelsInMap}
                />
            )}
            <UpcomingEvents
                showCreateEvent={showCreateEvent}
                toggleCreateEvent={toggleCreateEvent}
                eventPrefill={eventPrefill}
            />
            {showBobChat && <BobChatWidget showBobChat={showBobChat} toggleBobChat={toggleBobChat} />}
            {error && <h1 className="center-absolute">{error}</h1>}
        </Fragment>
    );
};

GeoLocation.defaultProps = {};

const mapStateToProps = (state) => ({
    position: state.user.position,
    errorMessage: state.user.errorMessage,
    userId: state.user.user?.id,
    taskList: state.tasks.tasklist,
    ui: state.ui,
    upcomingTaskList: state.tasks.upcomingTaskList,
});

GeoLocation.propTypes = {
    position: PropTypes.object,
    errorMessage: PropTypes.string,
    userId: PropTypes.string,
};

export default connect(mapStateToProps, { getPublicTask, getTaskByassignedToId })(GeoLocation);
